<template>
    <v-app id="dashboard-view" wrap style="background-color: #FAFAFA;">
        <GlobalToolbar/>
        <GlobalDrawer/>
        <v-main >
          <v-fade-transition mode="out-in">
            <v-container fluid class="pr-5">
              <router-view />
            </v-container>
          </v-fade-transition>
        </v-main>
    </v-app>
</template>


<script>
  export default {
    name: "DashboardView",
    metaInfo() {
      return {
        title: "Aprovação Brasil"
      };
    }
  };
</script>
